import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoreDetailComponent } from './components/score-detail/score-detail.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import { PaginatorCustomPIntl } from './helpers/paginationCustomIntel';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { FooterComponent } from 'app/widgets/footer/footer.component';
import { FooterUnauthenticatedComponent } from 'app/widgets/footer-unauthenticated/footer-unauthenticated.component';

const components = [ScoreDetailComponent, EmptyStateComponent, FooterComponent, FooterUnauthenticatedComponent]

const modules = [NgbTooltipModule, MatPaginatorModule]
@NgModule({
  declarations: [components],
  imports: [CommonModule, modules],
  exports: [components, modules],
  providers: [{provide: MatPaginatorIntl, useClass: PaginatorCustomPIntl}],
})
export class SharedModule { }
